export function getOrderIdentityKey(order) {
  return `HT-ORDERS-${order.id}`;
}
